import axios from "axios";
import Cookies from "js-cookie";
import { withApiErrorResponse, apiErrorMessage } from "../utils/apiError";

const url = () => `${(process.env.REACT_APP_BASE_BACKEND_API_URL || "").replace(/\/$/, "")}/api/v1/inventory/column-mapping`;

async function request(method, path, params, data, signal) {
  const response = await axios.request({
    method, url: `${url()}${path}`, params, data, signal,
    headers: { Authorization: `Bearer ${Cookies.get("accessToken")}` },
  });
  const result = response.data;
  if (result?.header?.code != null && Number(result.header.code) !== 600) {
    const error = new Error(apiErrorMessage(result) || result?.header?.message || "Column mapping request failed.");
    error.response = response;
    throw withApiErrorResponse(error);
  }
  return result?.body?.value ?? result?.body ?? result;
}

export const fetchMappingWorkflows = (params, signal) => request("get", "/workflows", params, undefined, signal);
export const fetchMappingFields = (params, signal) => request("get", "/fields", params, undefined, signal);
export const fetchMappingTargetColumns = (params, signal) => request("get", "/target-columns", params, undefined, signal);
export const fetchColumnMappings = (params, signal) => request("get", "", params, undefined, signal);
export const saveColumnMappings = (payload) => request("post", "/save", { organizationId: payload.organizationId }, payload);
export const setColumnMappingStatus = (id, isActive, organizationId) => request("put", `/${encodeURIComponent(id)}/status`, { isActive, organizationId });
export const deleteColumnMapping = (id, organizationId) => request("delete", `/${encodeURIComponent(id)}`, { organizationId });

export function mappingList(data, key) {
  if (Array.isArray(data)) return data;
  for (const value of [data?.[key], data?.content, data?.items, data?.data]) {
    if (Array.isArray(value)) return value;
  }
  throw new Error("Unexpected column mapping response. Please check the API response format.");
}

// The dedicated /workflows endpoint supplies eligible workflows. When a type is
// present, exclude explicitly unrelated types without relying on editable names.
export function eligibleWorkflows(data) {
  return mappingList(data, "workflows").filter((workflow) => {
    const type = workflow.workflowType ?? workflow.type;
    return type == null || String(type).replace(/[\s-]+/g, "_").toUpperCase() === "METER_REPLACEMENT";
  }).map((workflow) => ({
    value: String(workflow.workflowId ?? workflow.id),
    label: workflow.workflowName ?? workflow.name ?? workflow.title ?? String(workflow.workflowId ?? workflow.id),
  })).filter((option) => option.value !== "undefined");
}

export function targetColumns(data, role) {
  const source = data?.[role] ?? data;
  return mappingList(source, "targetColumns").map((column) => typeof column === "string"
    ? { value: column, label: column }
    : { value: column.targetColumn ?? column.columnName ?? column.key ?? column.name, label: column.label ?? column.displayName ?? column.targetColumn ?? column.columnName ?? column.name }
  ).filter((column) => column.value);
}
